import React from 'react';

const PaymentSuccess = () => {
    return (
        <div className="payment-message success">
            <p className='text-green-600 text-lg'>Payment Successful!</p>
        </div>
    );
};

const PaymentFailure = () => {
    return (
        <div className="payment-message failure">
            <p className='text-red-600 text-lg'>Payment Failed!</p>
        </div>
    );
};

export { PaymentSuccess, PaymentFailure };
